import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-burn-cards',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './burn-cards.component.html',
    styleUrl: './burn-cards.component.scss'
})
export class BurnCardsComponent {
    /**
     * New deck's first card id.
     */
    @Input()
    card?: number;

    /**
     * Number of cards already burned.
     */
    @Input()
    burnedCardsCount = 0;
}
